module.exports = __webpack_public_path__ + "static/img-home-1d38e1196ecc844c351212fcb64c05d3.jpg";